const NewCalendarIcon = ({ width = 24, height = 24, color = '#86868B' }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path d="M4 20L4 7L20 7L20 20H4Z" stroke={color} strokeWidth="2.05714" />
      <path d="M7 11H11" stroke={color} strokeWidth="2.05714" />
      <path d="M8 6V4" stroke={color} strokeWidth="2.05714" />
      <path d="M17 6V4" stroke={color} strokeWidth="2.05714" />
    </svg>
  )
}

export default NewCalendarIcon
